import { FormEvent, useEffect, useMemo, useRef } from 'react'
import { Proposal } from '../../shared/types'
import { useObjectActionMutation, useObjectList } from '../api/object'
import { Button } from '../components/button'
import { Dialog } from '../components/dialog'
import { Input } from '../components/input'

type AcceptProps = {
	proposal: Proposal
	onClose: VoidFunction
}

export function Accept({ proposal, onClose }: AcceptProps) {
	const {
		mutate: accept,
		status,
		data: response,
	} = useObjectActionMutation('proposal', proposal.id, 'accept', [['api', 'proposal_item']])
	const autoSent = useRef(false)
	const { data: { list: proposalItems = [] } = {} } = useObjectList('proposal_item', {
		page: -1,
		orderKey: 'id',
		orderDir: 'ASC',
		proposal_id: proposal.id,
	})

	const isValid = useMemo(() => {
		return proposalItems.some(item => item.proposal_vehicle_id === proposal.proposal_vehicle_id)
	}, [proposalItems])

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault()
		const formData = new FormData(event.currentTarget)
		accept(formData, {
			onSuccess: () => onClose(),
		})
	}

	useEffect(() => {
		if (autoSent.current) return
		if (isValid) {
			autoSent.current = true
			accept({})
			onClose()
		}
	}, [isValid, status, response])

	if (isValid) {
		return null
	}

	return (
		<Dialog heading="Přijmout poptávku" isOpen onOpenChange={onClose}>
			<form className="m-4 space-y-4" onSubmit={onSubmit}>
				<p>Vyplňte ceny rezervace</p>
				<Input type="text" label="Cena za den" name="cena_za_den" />
				<Input type="text" label="Cena za nadlimitní km" name="cena_za_nadlimitni_km" />
				<Input type="text" label="Nadlimitní km v ceně" name="nadlimitni_km_v_cene" />
				<Button type="submit" variant="PRIMARY" isPending={status === 'pending'}>
					Přijmout
				</Button>
			</form>
		</Dialog>
	)
}
